var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareArrow = function SvgShareArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 21.661"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.77 9.099 16.218.163a.49.49 0 0 0-.379-.162c-.3.014-.677.223-.677.542v4.481a.29.29 0 0 1-.244.278c-9.5 1.455-13.5 8.563-14.913 15.942-.054.291.338.562.521.332 3.466-4.366 7.683-7.216 14.351-7.27a.335.335 0 0 1 .284.325v4.4a.581.581 0 0 0 .982.359l9.619-9.091a.75.75 0 0 0 .237-.569.9.9 0 0 0-.229-.631"
  })));
};
export default SvgShareArrow;